__turbopack_context__.v({
  "address": "RepairRequestBoutiqueSummary-module-scss-module__I53rhG__address",
  "name": "RepairRequestBoutiqueSummary-module-scss-module__I53rhG__name",
});
